import React from 'react';
import "../styles/MatchDraw.css"

const MatchDraw = ({handleClick_matchDraw_continueSolving, handleClick_matchDraw_goHome}) => {
    return (
        <div className='MatchDraw__container'>
            <div className='MatchDraw_inner_div'>
                <h2><svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-timer-icon lucide-timer"><line x1="10" x2="14" y1="2" y2="2" /><line x1="12" x2="15" y1="14" y2="11" /><circle cx="12" cy="14" r="8" /></svg>Time Up</h2>
                <p>You couldn’t solve the problem in time.</p>
                <div className='MatchDraw_cta_div'>
                    <button onClick={handleClick_matchDraw_goHome} className='MatchDraw_cta_btn'>Go Home</button>
                    <button onClick={handleClick_matchDraw_continueSolving}  className='MatchDraw_cta_btn MatchDraw_cta_btn_positive'>Continue Solving</button>
                </div>
            </div>
        </div>
    );
}

export default MatchDraw;
